import { alpha, ListItem, styled } from "@mui/material";

const SyncStyledListItem = styled(ListItem)<{ error?: boolean }>(
  ({ theme, error }) =>
    error && {
      background: alpha(theme.palette.error.main, 0.2),
      paddingTop: 16,
      paddingBottom: 16,
      "&::before": {
        content: "''",
        height: "100%",
        position: "absolute",
        width: 40,
        left: -40,
        background: alpha(theme.palette.error.main, 0.2),
      },
      "&::after": {
        content: "''",
        height: "100%",
        position: "absolute",
        width: 40,
        right: -40,
        background: alpha(theme.palette.error.main, 0.2),
      },
    }
);

export default SyncStyledListItem;
